class Marquee {
  constructor(selector) {
    this.elements = document.querySelectorAll(selector);
    this.instances = [];
    this.init();
  }

  init() {
    this.elements.forEach((el) => {
      const rawSpeed = parseFloat(el.getAttribute('data-speed')) || 2;
      const speed = 1 / rawSpeed;
      this.instances.push(new MarqueeInstance(el, speed));
    });
  }
}

class MarqueeInstance {
  constructor(el, speed) {
    this.el = el;
    this.speed = speed;
    this.mouseEntered = false;
    this.progress = 1;
    this.container = this.el.querySelector('.inner');
    this.content = this.container.querySelector('.inner > *');
    this.elWidth = this.content.offsetWidth;
    this.cloneContent();
    this.addEventListeners();
    this.loop();
  }

  cloneContent() {
    let clone = this.content.cloneNode(true);
    this.container.appendChild(clone);
  }

  addEventListeners() {
    this.container.addEventListener('mouseenter', () => {
      this.mouseEntered = true;
    });
    this.container.addEventListener('mouseleave', () => {
      this.mouseEntered = false;
    });
  }

  loop() {
    if (!this.mouseEntered) {
      this.progress -= this.speed;
    }
    if (this.progress <= this.elWidth * -1) {
      this.progress = 0;
    }
    this.container.style.transform = `translateX(${this.progress}px)`;
    window.requestAnimationFrame(() => this.loop());
  }
}

// Usage example:
new Marquee('.marquee');


/*
function handleMarquee(){
  const marquee = document.querySelectorAll('.marquee');
  let speed = 2;
  let lastScrollPos = 0;
  let timer;

  marquee.forEach(function(el){
    // stop animation on mouseenter
    mouseEntered = false;
    document.querySelector('.inner').addEventListener('mouseenter', function() {
      mouseEntered = true;
    })
    document.querySelector('.inner').addEventListener('mouseleave', function() {
      mouseEntered = false
    })

    const container = el.querySelector('.inner');
    const content = el.querySelector('.inner > *');
    //Get total width
    const  elWidth = content.offsetWidth;
    
    //Duplicate content
    let clone = content.cloneNode(true);
    container.appendChild(clone);
    
    let progress = 1;
    function loop(){
      if (mouseEntered === false) {progress = progress-speed;} 
      if (progress <= elWidth*-1) {progress=0;}
      container.style.transform = 'translateX(' + progress + 'px)';
      window.requestAnimationFrame(loop);
    }
    loop();
  });
  
  function handleSpeedClear(){
    speed = 2;
  }
};

handleMarquee();
*/